// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Ga4Publisher$Catalyst from "./publishers/Ga4Publisher.bs.js";

function getGa4EventPayload(payload) {
  return {
          category: payload.category,
          action: payload.action,
          label: payload.label,
          value: payload.value,
          nonInteraction: payload.nonInteraction
        };
}

function publishEventGa4(payload) {
  return Ga4Publisher$Catalyst.publishGa4Event(getGa4EventPayload(payload));
}

function getPageViewPayloadGa4(pageViewParams) {
  return {
          hitType: "pageview",
          page: pageViewParams.path,
          title: pageViewParams.title
        };
}

function publishPageviewGa4(pageViewParams) {
  return Ga4Publisher$Catalyst.publishGa4Pageview(getPageViewPayloadGa4(pageViewParams));
}

export {
  publishEventGa4 ,
  publishPageviewGa4 ,
  
}
/* Ga4Publisher-Catalyst Not a pure module */
